/**
 * [API] 교육신청
 * @module @apis/attend
 */

import axios from '@/user/apis/common/axios-handle-error.service'

/**
 * 강의 목록 조회
 * @method getLectures
 * @param {string} baseYm 조회할 강의의 기준 년월 (YYYYMM)
 * @returns {promise} {data} = response or error
 */
const getLectures = ({ baseYm }) => {
  return new Promise((resolve, reject) => {
    const url = `/api/lecture/v1/monthly-lectures/${baseYm}`
    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

/**
 * 강의 단일 조회
 * @method getLectureInfo
 * @param {string} id 선택된 강의 아이디
 * @returns {promise} {data} = response or error
 */
const getLectureInfo = (id) => {
  return new Promise((resolve, reject) => {
    const url = `/api/lecture/v1/lectures/${id}`
    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

/**
 * 강의 상세 설명 조회
 * @method getLectureDescription
 * @param {string} id 선택된 강의 아이디
 * @returns {promise} {data} = response or error
 */
const getLectureDescription = (id) => {
  return new Promise((resolve, reject) => {
    const url = `/api/lecture/v1/lectures/${id}/description`
    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

/**
 * 강의 신청
 * @method attenders
 * @param {string} lectureId 강의 아이디
 * @param {object} params 이에일, 이름, 회사명, 목적, 약관동의
 * @returns {promise} {data} = response or error
 */
const attenders = (lectureId, params) => {
  return new Promise((resolve, reject) => {
    const url = `/api/lecture/v1/lectures/${lectureId}/attenders`
    return axios
      .post(url, params)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

export const AttendService = {
  getLectures,
  getLectureInfo,
  getLectureDescription,
  attenders,
}
